<template>
  <div class="text-field p-absolute"
:class="'w-full' ?? fullWidth">
    <input
      :name="name"
      :class="inputClasses"
      :type="type"
      :placeholder="placeholderText"
      v-model="inputValue"
      @blur="onBlur"
    />
  </div>
</template>


<script setup>
import { computed, ref, watch } from 'vue';
import { validateTextField } from '../../utils/helpers.js';

const props = defineProps({
  id: String,
  ariaLabel: String,
  name: String,
  title: String,
  fullWidth: Boolean,
  type: String,
  value: String,
  placeholder: String,
  customClasses: String,
  minChar: Number
});

const inputValue = ref(props.value);
const isMobile = computed(() => window.innerWidth <= 1008);
const placeholderText = computed(() => props.placeholder || '');
const inputClasses = computed(() => `input`);


const emits = defineEmits(['update:fieldValue','action:onfocus', 'action:onblur','update:isInputValid']);

const onBlur = (event) => { 
  validateField();
  emits('action:onblur', event);
};

const validateField = () => {
  let isInputvalid = null;
  if (props.type === 'text'){
    isInputvalid = validateTextField(inputValue.value, props.minChar);
  }
  emits('update:isInputValid', isInputvalid);
};

watch(inputValue, (newValue) => {
  emits('update:fieldValue', inputValue.value);
  validateTextField(newValue, props.minChar);
});

watch(() => props.value, (newValue) => {
    inputValue.value = newValue;
});

</script>
